import { makeBaseSvgIconProps } from 'components/icons/_utils/makeBaseSvgIconProps'

export const IconOverview = () => (
  <svg {...makeBaseSvgIconProps('0 0 20 16')}>
    <g transform="translate(0, 0)">
      <line x1="0" y1="0.5" x2="20" y2="0.5" stroke="currentColor" strokeWidth="3" />
    </g>
    <g transform="translate(0, 6)">
      <line x1="0" y1="0.5" x2="12" y2="0.5" stroke="currentColor" strokeWidth="2" />
    </g>
    <g transform="translate(0, 12)">
      <line x1="0" y1="0.5" x2="10" y2="0.5" stroke="currentColor" strokeWidth="2" />
    </g>
    <g transform="translate(12, 6) scale(0.75)">
      <polygon
        points="5,0 6.18,3.82 10,4 7,6.5 8,10 5,8 2,10 3,6.5 0,4 3.82,3.82"
        fill="none"
        stroke="currentColor"
      />
    </g>
  </svg>
)
